import { useEffect, useMemo, useRef, useState } from 'react';
import { useCurrent } from '../useCurrent';
import { useDocumentListener } from '../useDocumentListener';
export function useAnimation(ref, active = true, options = {}) {
    const { classNames = {
        in: 'in',
        out: 'out',
        started: 'started',
        ended: 'ended',
    }, onAfterMount, onAfterAnimationEnded, onAnimationStart, canAnimate = true, canUnmount = true, } = options;
    const [canMount, setCanMount] = useState(false);
    const activeRef = useCurrent(active);
    const canUnmountRef = useCurrent(canUnmount);
    const animationEnded = useRef(false);
    const animationStarted = useRef(false);
    if (!canMount) {
        animationEnded.current = false;
    }
    useEffect(() => {
        if (active) {
            setCanMount(true);
        }
    }, [active]);
    useDocumentListener('animationstart', (e) => {
        var _a, _b;
        if (e.target === ref.current) {
            animationStarted.current = true;
            (_a = ref.current) === null || _a === void 0 ? void 0 : _a.classList.add('started');
            (_b = ref.current) === null || _b === void 0 ? void 0 : _b.classList.remove('ended');
            if (canMount)
                onAfterMount === null || onAfterMount === void 0 ? void 0 : onAfterMount();
            onAnimationStart === null || onAnimationStart === void 0 ? void 0 : onAnimationStart(e.target);
        }
    });
    useDocumentListener(['animationend', 'animationcancel'], (e) => {
        var _a, _b;
        if (e.target === ref.current) {
            if (!activeRef.current && canUnmountRef.current)
                setCanMount(false);
            animationEnded.current = true;
            animationStarted.current = false;
            (_a = ref.current) === null || _a === void 0 ? void 0 : _a.classList.add('ended');
            (_b = ref.current) === null || _b === void 0 ? void 0 : _b.classList.remove('started');
            onAfterAnimationEnded === null || onAfterAnimationEnded === void 0 ? void 0 : onAfterAnimationEnded();
        }
    });
    const animationClassNames = (canMount && canAnimate
        ? [
            classNames[active && canAnimate ? 'in' : 'out'],
            animationEnded.current && 'ended',
            animationStarted.current && 'started',
        ].filter(Boolean)
        : []).join(' ');
    return useMemo(() => ({
        canMount,
        animationClassNames,
    }), [animationClassNames, canMount]);
}
//# sourceMappingURL=useAnimation.prod.js.map